/**
 * An event counts as shared once the API's `shared` flag is set on it.
 *
 * @param {boolean} isShareable
 * @param {Object} [data] - event.data
 * @returns {boolean}
 */
export default function hasBeenShared(isShareable, data) {
  return isShareable && data?.shared === true;
}
